import React, { Component } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Modal from "react-responsive-modal";
import { Toastr, Button } from "@revvsales/components";

// Actions Imports
import {
  approveRejectDoc,
  fetchAndUpdateDocMeta,
  approvalStatusCheck,
} from "../../actions/DocumentActions";

import { EVENTS } from "../../constants";
import { AmplitudeUtils } from "../../utils";

class ApproveRejectConfirmation extends Component {
  state = { comment: "", errMsg: "" };

  _changeComment = e => {
    this.setState({ comment: e.target.value });
  };

  _approveRejectDoc = () => {
    if (this.props.view === "Reject" && !this.state.comment) {
      this.setState({ errMsg: "Enter your comments." });
    } else {
      this.props
        .approveRejectDoc(
          this.props.docID,
          { user_comment: this.state.comment },
          this.props.view === "Approve",
        )
        .then(() => {
          Toastr.showToastr({
            type: "success",
            message: `Document ${this.props.view}${
              this.props.view === "Approve" ? "d" : "ed"
            } successfully.`,
            timeout: 1000,
          });
          this.props.togglePopUp("showApproveRejectConfirmation", false);
          this.props.fetchAndUpdateDocMeta(this.props.docNo);
          this.props.approvalStatusCheck(JSON.parse(this.props.docID));
          // Amplitude call
          AmplitudeUtils.amplitudeLogEvent(
            this.props.view === "Approve"
              ? EVENTS.EVENT_NAMES.DOCUMENT_APPROVED
              : EVENTS.EVENT_NAMES.DOCUMENT_REJECTED,
            {
              ...this.props.document,
              documentNotesCount: this.props.documentNotes.length,
            },
          );
          // Amplitude call
        })
        .catch(() => {
          Toastr.showToastr({
            type: "success",
            message: `Oops! Couldn't ${
              this.props.view
            } document. Please try again.`,
            timeout: 3000,
          });
          this.props.togglePopUp("showApproveRejectConfirmation", false);
        });
    }
  };

  render() {
    return (
      <Modal
        open
        onClose={() =>
          this.props.togglePopUp("showApproveRejectConfirmation", false)
        }
        closeOnOverlayClick={false}
        center>
        <div className="approvalpopup">
          <div className="approvalpopup-header">
            <p>{this.props.view} Document</p>
          </div>
        </div>
        <div className="approvalpopup-note">
          <p className="approvalpopup-workflows-heading">
            {this.props.view === "Approve"
              ? "Click Approve if you want to approve the document. Once approved, your account executive will be able to send the document to your client. Click Cancel if you want to cancel the operation."
              : "You are rejecting this document. Enter your comments or reason for rejecting the document."}
          </p>
          <p className="approvalpopup-workflows-heading">
            {this.state.errMsg && (
              <div className="error-message-wrapper">
                <span className="error-message-icon">
                  <FontAwesomeIcon icon={["far", "times-circle"]} />
                </span>
                {this.state.errMsg}
              </div>
            )}
          </p>
          <textarea
            rows="5"
            value={this.state.comment}
            onChange={e => this._changeComment(e)}
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus
            data-test="approverejectconfirmation-textarea"
          />
        </div>
        <section className="createquotepopup-footer popup-footer clearfix">
          <div className="footer-actions">
            <Button
              className="btn-transparent"
              data-test="approve-document-cancel-button"
              onClick={() =>
                this.props.togglePopUp("showApproveRejectConfirmation", false)
              }>
              Cancel
            </Button>
            <Button
              data-test="approve-document-approve-button"
              className={`${
                this.props.view === "Reject" ? "reject-document" : ""
              }`}
              onClick={() => this._approveRejectDoc()}>
              {this.props.view}
            </Button>
          </div>
        </section>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  const { document } = state.DocumentStore;
  const { id: docID, docNo } = document;
  const { documentNotes } = state.NotesStore;
  return { docID, docNo, document, documentNotes };
};

const mapDispatchToProps = {
  approveRejectDoc,
  fetchAndUpdateDocMeta: docNo => fetchAndUpdateDocMeta(docNo),
  approvalStatusCheck: (docID, status) => approvalStatusCheck(docID, status),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ApproveRejectConfirmation);



// WEBPACK FOOTER //
// ./src/components/DocumentApprovalPopupNew/ApproveRejectConfirmation.js